export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviews.vue?vue&type=template&id=f29f4cba&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/reviews.vue?vue&type=template&id=f29f4cba&
// module id = 1616
// module chunks = 0